/**
 * Landing Cinta Modeladora — lunins.com.br/cinta
 * Copy alinhada à política de marca (sem FisioPower espontâneo, sem corrente russa).
 */

export const CINTA_WA_E164 =
  import.meta.env.VITE_CINTA_WA_E164?.trim() || '5567992089769';

export const CINTA_LANDING = {
  slug: 'cinta',
  pageTitle: 'Cinta Modeladora Lunins | Campanha Bem-Estar — 12x R$ 99',
  metaDescription:
    'Cinta Modeladora Lunins com vibroterapia e manta térmica. Frete grátis, NF-e, garantia 12 meses. Campanha Bem-Estar — 12x de R$ 99 no cartão.',

  hero: {
    eyebrow: 'Campanha Bem-Estar · Lunins · Campo Grande/MS',
    headline: 'Sinta leveza e modelagem em 20 minutos — no conforto da sua casa',
    subheadline:
      'Vibroterapia de alta frequência + manta térmica integrada numa única cinta. Liga na tomada, ajusta no corpo e relaxa. Resultados progressivos com uso diário.',
    anchorFull: 'R$ 1.980',
    installment: '12x de R$ 99',
    cta: 'Quero a minha',
  },

  trust: [
    { title: 'NF-e automática', desc: 'Nota fiscal emitida direto no seu e-mail após confirmação do pagamento.', icon: 'receipt' as const },
    { title: 'Garantia 12 meses', desc: 'Manutenção vitalícia e suporte humano pelo WhatsApp.', icon: 'shield' as const },
    { title: 'Frete grátis', desc: 'Enviamos para todo o Brasil sem custo adicional.', icon: 'truck' as const },
    { title: 'Empresa real', desc: 'Lunins · Campo Grande/MS · anos de atuação em bem-estar.', icon: 'building' as const },
  ],

  howItWorks: [
    {
      title: 'Vibroterapia de alta frequência',
      desc: 'São ~1.200 micro-estímulos por sessão de 20 min. A vibração promove sensação de leveza e apoia o processo de modelagem.',
      icon: 'vibration' as const,
    },
    {
      title: 'Manta térmica integrada',
      desc: 'O calor local gradual eleva o conforto e potencializa o efeito da vibroterapia durante o uso.',
      icon: 'heat' as const,
    },
    {
      title: 'Multirregião',
      desc: 'Uma única cinta versátil: coxas, glúteo, culotes, lombar e bíceps — tudo com a mesma peça.',
      icon: 'body' as const,
    },
  ],

  regions: [
    { label: 'Coxas', emoji: '🦵', desc: 'Frontal e posterior — reduz inchaço e apoia modelagem das coxas', gradient: 'from-emerald-500/20 to-teal-500/10' },
    { label: 'Glúteo', emoji: '🍑', desc: 'Vibroterapia focada para modelagem e relaxamento dos glúteos', gradient: 'from-rose-500/20 to-pink-500/10' },
    { label: 'Culotes', emoji: '⚡', desc: 'Lateral do quadril — região de culotes com vibração localizada', gradient: 'from-amber-500/20 to-orange-500/10' },
    { label: 'Lombar', emoji: '🔥', desc: 'Manta térmica + vibração nas costas baixas — alívio e conforto', gradient: 'from-blue-500/20 to-indigo-500/10' },
    { label: 'Bíceps', emoji: '💪', desc: 'Braços — região do bíceps com vibroterapia de alta frequência', gradient: 'from-violet-500/20 to-purple-500/10' },
  ],

  testimonials: {
    headline: 'Quem já usa, recomenda',
    subtitle: 'Depoimentos reais de clientes que usam a cinta no dia a dia.',
    items: [
      {
        video: '/videos/depoimento-cinta-1.mp4',
        name: 'Solange',
        location: 'Dourados/MS',
        highlight: '"Uso há 3 meses e estou vendo muitos resultados — recomendo!"',
        usagePeriod: 'Usa há 3 meses',
      },
      {
        video: '/videos/depoimento-cinta-2.mp4',
        name: 'Ivanice',
        location: 'Barra do Garças/MT',
        highlight: '"Notei diferença significativa desde o primeiro uso"',
        usagePeriod: 'Resultado desde o 1º uso',
      },
    ],
  },

  tutorials: {
    youtube: [
      { id: 'Ux99JwwUHo0', title: 'Tutorial Pamela — uso e cuidados' },
      { id: 'FlbQz2bS4ak', title: 'Tutorial Pamela — regiões de aplicação' },
    ],
  },

  heroVideo: '/videos/cinta-anuncio.mp4',
  heroPoster: '/images/cinta/poster-anuncio.webp',
  catalogImage: '/images/cinta/catalogo.jpeg',

  authority: [
    'Salas de descompressão Lunins instaladas em instituições públicas de MS',
    'Marca @luninsbr — referência em bem-estar e equipamentos no Mato Grosso do Sul',
    'Atendimento 100% humano pelo WhatsApp — antes, durante e depois da compra',
    'Mais de mil clientes atendidos entre Campo Grande e interior',
  ],

  faq: [
    {
      q: 'É golpe? A Lunins existe?',
      a: 'Somos Lunins (L.D.Z Arquitetura Bem Estar LTDA, CNPJ 63.105.156/0001-57), de Campo Grande/MS. Pagamento via Mercado Pago com Compra Garantida — seu dinheiro fica protegido até você receber. NF-e após confirmação e suporte pelo WhatsApp.',
    },
    {
      q: 'Funciona mesmo?',
      a: 'A Cinta combina vibroterapia e manta térmica para apoiar modelagem e sensação de leveza com uso regular (~20 min, umas 3x por semana). Resultados variam com constância — veja os depoimentos reais na seção “Quem já usa”. Não prometemos emagrecimento garantido.',
    },
    {
      q: 'Ajuda no estômago alto / barriga alta?',
      a: 'Sim — a vibroterapia faz uma massagem intensa no abdômen: relaxa, ativa a musculatura e alivia a sensação de barriga inchada ou pesada. Quando o “estômago alto” vem de inchaço, gases, retenção ou intestino lento, muita gente percebe a região menos estufada. É aliada no cuidado da gordura abdominal com uso constante + alimentação e atividade física. O resultado varia conforme a causa; não substitui orientação médica.',
    },
    {
      q: 'Tem contraindicação?',
      a: 'Gestantes, portadores de marcapasso, feridas abertas na região ou condições médicas específicas devem consultar um profissional de saúde antes do uso.',
    },
    {
      q: 'Posso trocar se não gostar?',
      a: 'Troca em até 7 dias após recebimento, produto lacrado e sem uso, conforme CDC.',
    },
    {
      q: 'Qual o prazo de entrega?',
      a: 'Frete grátis para todo o Brasil. O prazo varia conforme sua região — informamos após confirmação do pagamento.',
    },
    {
      q: 'Formas de pagamento?',
      a: '12x de R$ 99 no cartão via Mercado Pago com Compra Garantida nesta campanha. Pix e outras condições podem ser negociadas pelo WhatsApp.',
    },
  ],

  urgency:
    'Condição exclusiva da Campanha Bem-Estar — valores desta página enquanto a campanha estiver ativa.',

  whatsappPrefill:
    'Olá! Vi a Cinta Modeladora na página lunins.com.br/cinta e quero saber mais sobre a Campanha Bem-Estar.',

  footer: {
    cnpj: 'L.D.Z Arquitetura Bem Estar LTDA · CNPJ 63.105.156/0001-57',
    lgpd: 'Seus dados são usados apenas para pedido, NF-e e contato comercial.',
    troca: 'Troca em 7 dias — produto lacrado, sem uso.',
    contato: 'WhatsApp Lunins',
  },
} as const;
